/* eslint-disable parog-web/no-glint-expect-error-directive */
import type { TOC } from '@ember/component/template-only';
import { concat, hash } from '@ember/helper';
import t from 'ember-intl/helpers/t';
import capitalize from 'parog-web/helpers/capitalize';
import tWithDefault from 'parog-web/helpers/t-with-default';
import type MedicModel from 'parog-web/models/medic';
import DashIfEmpty from 'ui-kit/components/dash-if-empty';
import fuiAccordion from 'wise-fui-modules/modifiers/fui-accordion';

interface Signature {
  Args: {
    isCareGiver?: boolean;
    medics: Array<MedicModel & { comments?: unknown }>;
    medicTypePrefix: string;
  };
  Blocks: {
    default: [{ medic: MedicModel }];
  };
}

export default <template>
  <div {{fuiAccordion}} class='ui accordion'>
    {{#each @medics as |medic|}}
      <div
        class='title'
        data-test={{@medicTypePrefix}}
        data-test-id={{medic.id}}
      >
        <i class='dropdown icon'></i>
        {{medic.firstName}}
        {{medic.lastName}}
        <span class='time-label'>
          {{#if @isCareGiver}}
            {{capitalize
              (tWithDefault (concat 'careGiver.role.' medic.role) medic.role)
            }}
          {{else}}
            {{capitalize (t (concat @medicTypePrefix '.role.' medic.role))}}
          {{/if}}
          {{medic.professionalId}}
        </span>
      </div>
      <div
        class='content time-label ml4'
        data-test={{concat @medicTypePrefix '-details'}}
        data-test-id={{medic.id}}
        data-test-global={{concat medic.id '-details'}}
      >

        <i class='mobile alternate icon'></i>
        <DashIfEmpty @value={{medic.phone}} /><br />

        {{#if medic.fax}}
          <i class='fax alternate icon'></i>
          <DashIfEmpty @value={{medic.fax}} /><br />
        {{/if}}

        <i class='at icon'></i>
        <DashIfEmpty @value={{medic.email}} /><br />

        {{#if medic.secureEmail}}
          <i class='lock icon'></i>
          <DashIfEmpty @value={{medic.secureEmail}} /><br />
        {{/if}}

        <i class='envelope icon outline'></i>
        <DashIfEmpty @value={{medic.address}} /><br />

        {{#if medic.comments}}
          <i class='comment icon outline'></i>

          {{! @glint-expect-error }}
          <DashIfEmpty @value={{medic.comments}} /><br />
        {{/if}}

        {{yield (hash medic=medic)}}
      </div>
    {{/each}}
  </div>
</template> satisfies TOC<Signature>;
